var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{tag:"component",staticClass:"button",attrs:{"href":_vm.href},on:{"click":_vm.onClickFunction}},[_vm._v(" "+_vm._s(_vm.label_button)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }